import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const initialState = {
  searches: {
    byId: {},
    ids: []
  },
  currentSearchId: null,
  isSubscribeModalOpen: false
};

const fetchSearchesSuccess = (draft, action) => {
  const {
    searches
  } = action.payload;
  searches.forEach(search => {
    draft.searches.byId[search.id] = search;
  });
  draft.searches.ids = searches.map(search => search.id);
};

const fetchSearchSuccess = (draft, action) => {
  const {
    search
  } = action.payload;
  draft.searches.byId[search.id] = search;
};

const openSubscribeModal = draft => {
  draft.isSubscribeModalOpen = true;
};

const closeSubscribeModal = draft => {
  draft.isSubscribeModalOpen = false;
};

const setCurrentSearch = (draft, action) => {
  draft.currentSearchId = action.payload.currentSearchId;
};

const savedSearchesSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchSearchesSuccess,
    fetchSearchSuccess,
    openSubscribeModal,
    closeSubscribeModal,
    setCurrentSearch
  }
});
export const {
  actions
} = savedSearchesSlice;
export const plug = {
  [stateName]: savedSearchesSlice.reducer
};
export default savedSearchesSlice.reducer;